import React from 'react';

// Code 128 symbol patterns, ordered by symbol value (0–106).
const patterns = [
    '11011001100', '11001101100', '11001100110', '10010011000', '10010001100', '10001001100',
    '10011001000', '10011000100', '10001100100', '11001001000', '11001000100', '11000100100',
    '10110011100', '10011011100', '10011001110', '10111001100', '10011101100', '10011100110',
    '11001110010', '11001011100', '11001001110', '11011100100', '11001110100', '11101101110',
    '11101001100', '11100101100', '11100100110', '11101100100', '11100110100', '11100110010',
    '11011011000', '11011000110', '11000110110', '10100011000', '10001011000', '10001000110',
    '10110001000', '10001101000', '10001100010', '11010001000', '11000101000', '11000100010',
    '10110111000', '10110001110', '10001101110', '10111011000', '10111000110', '10001110110',
    '11101110110', '11010001110', '11000101110', '11011101000', '11011100010', '11011101110',
    '11101011000', '11101000110', '11100010110', '11101101000', '11101100010', '11100011010',
    '11101111010', '11001000010', '11110001010', '10100110000', '10100001100', '10010110000',
    '10010000110', '10000101100', '10000100110', '10110010000', '10110000100', '10011010000',
    '10011000010', '10000110100', '10000110010', '11000010010', '11001010000', '11110111010',
    '11000010100', '10001111010', '10100111100', '10010111100', '10010011110', '10111100100',
    '10011110100', '10011110010', '11110100100', '11110010100', '11110010010', '11011011110',
    '11011110110', '11110110110', '10101111000', '10100011110', '10001011110', '10111101000',
    '10111100010', '11110101000', '11110100010', '10111011110', '10111101110', '11101011110',
    '11110101110', '11010000100', '11010010000', '11010011100', '1100011101011'
];

export function answerSheetBarcodeValue(processo, user) {
    const cargo = String(processo?.id ?? '').trim();
    const inscricao = String(user?.numero_inscricao ?? '').trim();
    // Use the actual registration, never the editable display text or a candidate tag.
    if (!cargo || !inscricao) return null;
    const value = `${cargo}|${inscricao}`;
    return /^[\x20-\x7e]+$/.test(value) ? value : null;
}

export function encodeCode128B(value) {
    if (!value || !/^[\x20-\x7e]+$/.test(value)) return null;
    const symbols = Array.from(value, character => character.charCodeAt(0) - 32);
    const checksum = (104 + symbols.reduce((sum, symbol, index) => sum + symbol * (index + 1), 0)) % 103;
    // Ten blank modules on both sides protect the barcode's quiet zones.
    return '0'.repeat(10) + [104, ...symbols, checksum, 106].map(symbol => patterns[symbol]).join('') + '0'.repeat(10);
}

export default function AnswerSheetBarcode({ processo, user, preview = false }) {
    const nominal = answerSheetBarcodeValue(processo, user);
    const value = nominal || (preview && processo?.id ? `${processo.id}|:inscricao_candidato` : null);
    const modules = encodeCode128B(value);
    if (!modules) return null;
    const bars = [];
    for (let index = 0; index < modules.length;) {
        const start = index;
        const black = modules[index] === '1';
        while (index < modules.length && modules[index] === modules[start]) index++;
        if (black) bars.push(<rect key={start} x={start} y="0" width={index - start} height="42" fill="#000" />);
    }
    return <div className="answer-sheet-barcode">
        <svg xmlns="http://www.w3.org/2000/svg" role="img" aria-label={`Código de barras: cargo ${processo.id}, inscrição ${user?.numero_inscricao || ':inscricao_candidato'}`}
            data-barcode-value={nominal || undefined} data-barcode-preview={!nominal || undefined} viewBox={`0 0 ${modules.length} 42`} width="360" height="42" preserveAspectRatio="none" shapeRendering="crispEdges">
            <rect width={modules.length} height="42" fill="#fff" />{bars}
        </svg>
        <div>Inscrição <b>{user?.numero_inscricao || ':inscricao_candidato'}</b> · Cargo ID <b>{processo.id}</b></div>
    </div>;
}
